// Tiny re-usable Excel/PDF export button pair. Drop in next to a table.
//
//   import ExportButtons from '../components/ExportButtons';
//   <ExportButtons rows={data} columns={cols} filename="assets" title="All Assets" />

import React from 'react';
import { MdFileDownload, MdPictureAsPdf } from 'react-icons/md';
import { exportToExcel, exportToPDF } from '../lib/exportTable';

const ExportButtons = ({
  rows = [], columns, filename = 'export', title, subtitle, summary,
  size = 'sm', orientation = 'landscape', disabled,
}) => {
  const noData = !rows || rows.length === 0;
  const xlsxName = `${filename}.xlsx`;
  const pdfName  = `${filename}.pdf`;

  const onExcel = () => exportToExcel(rows, {
    filename: xlsxName, sheetName: title || filename, columns, title, summary,
  });
  const onPdf = () => exportToPDF(rows, {
    filename: pdfName, title, subtitle, columns, summary, orientation,
  });

  const cls = `btn ${size === 'sm' ? 'btn-sm' : ''} btn-outline`;
  return (
    <div style={{ display: 'inline-flex', gap: 6 }}>
      <button className={cls} onClick={onExcel} disabled={disabled || noData}
        title={noData ? 'Nothing to export' : 'Download as Excel (.xlsx)'}>
        <MdFileDownload /> Excel
      </button>
      <button className={cls} onClick={onPdf} disabled={disabled || noData}
        title={noData ? 'Nothing to export' : 'Download as PDF'}>
        <MdPictureAsPdf /> PDF
      </button>
    </div>
  );
};

export default ExportButtons;
